import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation, useNavigate, Navigate } from "react-router-dom";
import AuthProtected from "./AuthProtected";
import { authProtectedRoutes, publicRoutes, DefaultRoutes } from "./allRoutes";
import Sidemenu from "../components/sideMenu";
import MobileSidemenu from "../components/MobileSidemenu";
import Navbar from "../components/navbar";
import ConfirmDialog from "../components/deleteModal";

const Index = () => {
  const location = useLocation();
  const publicPaths = publicRoutes.map((r) => r.path);
  const isPublicPath = publicPaths.includes(location.pathname);

  // Detect mobile screen
  const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth < 640);

  // Desktop sidebar width
  const [sidebarWidth, setSidebarWidth] = useState(isMobileScreen ? 0 : 55);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const mobile = width < 640;
      setIsMobileScreen(mobile);
      if (mobile) {
        setSidebarWidth(0);
        setSidebarOpen(false);
      } else {
        // If viewport is too narrow (e.g. inspector opened), collapse sidebar
        if (width < sidebarWidth + 300) {
          setSidebarOpen(false);
          setSidebarWidth(55);
        }
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [sidebarWidth]);

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("access_token");
    setLogoutDialogOpen(false);
    navigate("/login");
  };

  return (
    <>
      {/* Fixed Navbar at top — outside flex container to avoid layout interference */}
      {!isPublicPath && !isMobileScreen && (
        <Navbar
          open={sidebarOpen}
          onDrawerOpen={() => { setSidebarOpen(true); setSidebarWidth(225); }}
          onDrawerClose={() => { setSidebarOpen(false); setSidebarWidth(55); }}
          onLogoutClick={() => setLogoutDialogOpen(true)}
        />
      )}

      <div style={{ display: "flex", flexDirection: "row", width: "100%", height: "100vh", overflow: "hidden" }}>
        {/* Desktop Sidebar */}
        {!isPublicPath && !isMobileScreen && (
          <div
            style={{
              width: sidebarWidth,
              flexShrink: 0,
              transition: "width 0.3s ease",
              overflow: "hidden",
              height: "100vh",
            }}
          >
            <Sidemenu
              open={sidebarOpen}
              onClose={() => { setSidebarOpen(false); setSidebarWidth(55); }}
              onOpen={() => { setSidebarOpen(true); setSidebarWidth(225); }}
            />
          </div>
        )}

        {/* Mobile Sidebar Drawer */}
        {!isPublicPath && isMobileScreen && <MobileSidemenu />}

        {/* Main Content */}
        <div style={{ flex: 1, minWidth: 0, maxWidth: "100%", background: "#f4f6f9", overflow: "hidden", height: "100vh", display: "flex", flexDirection: "column" }}>
          {/* Spacer for fixed Navbar */}
          {!isPublicPath && !isMobileScreen && <div style={{ height: "65px", flexShrink: 0 }} />}

          <div style={{ margin: 0, padding: "24px 24px", width: "100%", boxSizing: "border-box", flex: 1, overflow: "auto", minHeight: 0 }}>
            <Routes>
              <Route path="/" element={<Navigate to="/login" replace />} />
              {DefaultRoutes.map((route: any, idx: number) => (
                <Route key={idx} path={route.path} element={route.component} />
              ))}
              {publicRoutes.map((route: any, idx: number) => (
                <Route key={idx} path={route.path} element={route.component} />
              ))}
              {authProtectedRoutes.map((route: any, idx: number) => (
                <Route
                  key={idx}
                  path={route.path}
                  element={<AuthProtected>{route.component}</AuthProtected>}
                />
              ))}
            </Routes>
          </div>
        </div>
      </div>

      {/* Logout Confirmation Dialog — dialogs should be outside the flex layout */}
      <ConfirmDialog
        open={logoutDialogOpen}
        onClose={() => setLogoutDialogOpen(false)}
        onConfirm={handleLogout}
        variant="logout"
      />
    </>
  );
};

export default Index;
